import React from 'react'

const SvgVolumeMuteOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 16l4.537 3.927c.417.138.764.118 1.041-.058.278-.176.419-.476.422-.9l.004-13.679c.017-.576-.124-.953-.422-1.13-.298-.177-.645-.207-1.04-.09L6.003 8h-2C2.668 8.006 2 8.673 2 10v3.998c0 1.325.667 1.996 2 2.015L6 16zm.001-2.002h-2L4 10h2c.151 0 1.486-1.009 4.004-3.027v10.24C7.487 15.068 6.153 13.997 6 13.997h.001zm9.35 1.652l2.243-2.243 2.242 2.243c.464.48.935.48 1.415 0s.48-.95 0-1.414l-2.243-2.243L21.25 9.75c.471-.47.471-.942 0-1.414-.472-.47-.943-.47-1.415 0l-2.242 2.243-2.243-2.243c-.46-.482-.932-.482-1.414 0-.482.482-.482.954 0 1.414l2.242 2.243-2.242 2.243c-.472.47-.472.942 0 1.414s.943.472 1.414 0h.001z'
    />
  </svg>
)

export default SvgVolumeMuteOutline
